import React, { Component } from "react";
import axios from "axios";
import UserRolePopup from "app/shared/layout/header/user-role-popup";


class RoleContainer extends Component {
  state = {
    display: "",
    titles: [],
    seen: false
  };

  change = (event) => {

    this.setState({ value: event.target.value });
    axios.post("services/ainnotateservice/api/aidas-users/"+event.target.value).then((response) =>{
      if(response.data === 'No data'){
        this.togglePop();
      }
    })
  };


  togglePop = () => {
    this.setState({
      seen: !this.state.seen
    });
  };

  componentDidMount = () => {
    axios.get("services/ainnotateservice/api/my-authorities").then((response) =>
      this.setState({
        titles: response.data.map(({ name }) => name),
        display:
          response.data[Math.floor(Math.random() * response.data.length)].title
      })
    );
  };

  render() {
    const { display, titles } = this.state;
    return (
      <div className="container">
        <select onChange={this.change.bind(this)} value={this.state.display}>
          {titles.map((title) => (
            <option key={title} value={title}>
              {title}
            </option>
          ))}
        </select>
        <div>
          {this.state.seen ? <UserRolePopup toggle={this.togglePop.bind(this)} /> : null}
        </div>
      </div>
    );
  }
}
export default RoleContainer;
